<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>中华人民共和国(一)<br />企业所得税月(季)度预缴纳税申报表(A类，2021年版)</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table class="tax-v2025-en">
        <tbody>
          <tr>
            <td class="td-center" style="width: 150px">预缴方式</td>
            <td style="width: 300px">
              <el-radio disabled value="1" v-model="radio1">按照实际利润额预缴</el-radio>
              <!-- <input type="radio" id="radio1" name="type" disabled="disabled" value="1" checked="checked" />
              <label for="radio1">按照实际利润额预缴</label> -->
            </td>
            <td style="width: 300px">
              <el-radio disabled value="2" v-model="radio1">按照上一纳税年度应纳税所得额平均额预缴</el-radio>
              <!-- <input type="radio" id="radio2" name="type" disabled="disabled" value="2" />
              <label for="radio2">按照上一纳税年度应纳税所得额平均额预缴</label> -->
            </td>
            <td style="width: 300px">
              <el-radio disabled value="3" v-model="radio1">按照税务机关确定的其他方法预缴</el-radio>
              <!-- <input type="radio" id="radio3" name="type" disabled="disabled" value="3" />
              <label for="radio3">按照税务机关确定的其他方法预缴</label> -->
            </td>
          </tr>
          <tr>
            <td class="td-center">企业类型</td>
            <td>
              <el-radio disabled value="1" v-model="radio2">一般企业</el-radio>
              <!-- <input type="radio" id="radio1" name="cate" disabled="disabled" value="1" checked="checked" /><label for="radio1">一般企业</label> -->
            </td>
            <td>
              <el-radio disabled value="2" v-model="radio2">跨地区经营汇总纳税企业 总机构</el-radio>
              <!-- <input type="radio" id="radio2" name="cate" disabled="disabled" value="2" /><label for="radio2">跨地区经营汇总纳税企业 总机构</label> -->
            </td>
            <td>
              <el-radio disabled value="3" v-model="radio2">跨地区经营汇总纳税企业 分支机构</el-radio>
              <!-- <input type="radio" id="radio3" name="cate" disabled="disabled" value="3" /><label for="radio3">跨地区经营汇总纳税企业 分支机构</label> -->
            </td>
          </tr>

        <tr>
            <td>跨省总机构行政区划</td>
            <td></td>
            <td colspan="2" class="align-left">提示：总机构在外省的分支机构申报时，请先选择跨省总机构行政区划</td>
        </tr>
        </tbody>
      </table>
      <table class="">
        <colgroup>
          <col width="50" />
          <col />
        </colgroup>
        <thead>
          <tr class="table-head">
            <td colspan="13" class="bold-txt">优惠及附报事项有关信息</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3" rowspan="2" class="td-center">项目</td>
            <td colspan="2" class="td-center">一季度</td>
            <td colspan="2" class="td-center">二季度</td>
            <td colspan="2" class="td-center">三季度</td>
            <td colspan="2" class="td-center">四季度</td>
            <td colspan="2" rowspan="2" class="td-center"
                style="min-width: 110px;"
            >季度平均值</td>
          </tr>
          <tr>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
            <td class="td-center">季初</td>
            <td class="td-center">季末</td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">从业人数</td>
            <td class="td-center" data-position="v1x1">
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center" data-position="v1x2">
              <!-- 考题 -->
              <taxQue :data="data.v1x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x2.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x3.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x4.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x4.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x5.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x6" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x6.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x6.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x7" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x7.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x7.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x7.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v1x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x8.value" :controls="false" :precision="0" :step="1" :value-on-clear="0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x8.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td colspan="2" class="td-center">{{ data.v1x9.value }}</td>
          </tr>
          <tr>
            <td colspan="3" class="td-center">资产总额（万元）</td>
            <td class="td-center" data-position="v2x1">
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x6" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x7" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x7.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x7.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v2x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v2x9.value) }}</td>
          </tr>

          <tr>
            <td colspan="5" class="td-center">国家限制或禁止行业</td>
            <td colspan="2" class="td-center" data-position="v3x1">
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v3x1.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v3x1.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v3x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                    style="max-width: 200px"
                  />
                </template>
              </taxQue>
              <!-- <label><input type="radio" name="data_h_3_1" value="1" checked="checked" style="width: 20px" />是</label>
              <label><input type="radio" name="data_h_3_1" value="-1" style="width: 20px" />否</label> -->
            </td>
            <td colspan="4" class="td-center">小型微利企业</td>
            <td colspan="2" class="td-center" data-position="v3x2">
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v3x2.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v3x2.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v3x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                    style="max-width: 200px"
                  />
                </template>
              </taxQue>
              <!-- <label><input type="radio" name="data_h_3_2" value="1" checked="checked" style="width: 20px" />是</label>
              <label><input type="radio" name="data_h_3_2" value="-1" style="width: 20px" />否</label> -->
            </td>
          </tr>


          <tr>
            <td colspan="9" class="td-center bold-txt">附报事项名称</td>
            <td colspan="4" class="td-center bold-txt">金额或选项</td>
          </tr>

          <tr>
              <td rowspan="2" style="min-width: 60px;">事项1</td>
              <td rowspan="2" colspan="2" data-position="v5x1">
                  <el-checkbox style="margin: 0 10px"
                               value="1"
                               v-model="data.v5x1.value">职工薪酬</el-checkbox>
              </td>
              <td colspan="6">已计入成本费用的职工薪酬（单位：元）	</td>
              <td colspan="4" data-position="v5x3">
                  <taxQue :data="data.v5x3" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td colspan="6">实际支付给职工的应付职工薪酬（单位：元）	</td>
              <td colspan="4" data-position="v6x3">
                  <taxQue :data="data.v6x3" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td>事项2</td>
              <td colspan="8">
                  <el-checkbox style="margin: 0 10px"
                               :true-value="1"
                               :false-value="0"
                               v-model="data.v7x1.value">出口方式</el-checkbox>
              </td>

              <td colspan="4">
                      <el-check-multi-group
                          style="display: flex;flex-wrap: wrap;"
                          v-model="data.v7x2.value">
                          <div>
                              <el-checkbox label="" value="1">
                                  发生了自营出口业务
                              </el-checkbox>
                              <el-checkbox label="" value="2">
                                  发生了委托出口业务
                              </el-checkbox>
                          </div>

                          <el-checkbox label="" value="3">
                              承担了代理出口业务
                          </el-checkbox>
                      </el-check-multi-group>
              </td>
          </tr>
          <tr>
              <td>事项3</td>
              <td colspan="8">
                  <el-checkbox style="margin: 0 10px"
                               disabled
                               checked
                  ><span style="color: #333333;">资产损失</span></el-checkbox>
              </td>
              <td colspan="4" data-position="v8x2">
                  <taxQue :data="data.v8x2" :mode="mode">
                      <template #input>
                          <el-radio-group v-model="data.v8x2.value">
                              <el-radio value="1">是</el-radio>
                              <el-radio value="-1">否</el-radio>
                          </el-radio-group>
                      </template>
                      <template #score>
                          <el-radio-group v-model="data.v8x2.answer">
                              <el-radio value="1">是</el-radio>
                              <el-radio value="-1">否</el-radio>
                          </el-radio-group>

                          <el-input-number
                              placeholder="分值"
                              class="score-wrap-score"
                              v-model.trim="data.v8x2.score"
                              :controls="false"
                              :precision="1"
                              :step="0.1"
                              :max="100"
                              :min="0"
                              :value-on-clear="null"
                              style="max-width: 200px"
                          />
                      </template>
                  </taxQue>
              </td>
          </tr>
          <tr>
              <td>事项4</td>
              <td colspan="8">
                  <el-checkbox style="margin: 0 10px"
                               :true-value="1"
                               :false-value="0"
                               v-model="data.v9x1.value">扶贫捐赠支出全额扣除（本年累计，元）</el-checkbox>
              </td>
              <td colspan="4" data-position="v9x2">
                  <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </td>
          </tr>
          <tr>
              <td>事项5</td>
              <td colspan="8">
                  <el-checkbox style="margin: 0 10px"
                               :true-value="1"
                               :false-value="0"
                               v-model="data.v10x1.value">软件集成电路企业按新政策或原政策执行优惠</el-checkbox>
              </td>
              <td colspan="4" data-position="v10x2">
                  <el-check-multi-group
                      style="display: flex;flex-wrap: wrap;"
                      v-model="data.v10x2.value">
                          <el-checkbox label="" value="1">
                              原政策
                          </el-checkbox>
                          <el-checkbox label="" value="2">
                              新政策
                          </el-checkbox>
                  </el-check-multi-group>
              </td>
          </tr>




          <tr class="table-head">
            <td></td>
            <td colspan="12" class="td-center bold-txt">预缴税款计算</td>
          </tr>

          <tr>
            <td class="indent_1em">1</td>
            <td colspan="10" class="align-left">营业收入</td>
            <td colspan="2" data-position="v12x2">
              <!-- 考题 -->
              <taxQue :data="data.v12x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v12x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v12x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr>
              <td class="indent_1em">1.1</td>
              <td colspan="10" class="align-left"><span style="margin-left: 20px;"></span>其中：自营出口收入</td>
              <td colspan="2" data-position="v13x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v13x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v13x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">1.2</td>
              <td colspan="10" class="align-left"><span style="margin-left: 57px;"></span>委托出口收入</td>
              <td colspan="2" data-position="v14x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v14x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v14x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">1.3</td>
              <td colspan="10" class="align-left"><span style="margin-left: 57px;"></span>出口代理费收入</td>
              <td colspan="2" data-position="v15x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v15x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v15x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v15x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">2</td>
              <td colspan="10" class="align-left">减：营业成本</td>
              <td colspan="2" data-position="v16x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v16x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v16x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v16x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v16x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">3</td>
              <td colspan="10" class="align-left">减：税金及附加</td>
              <td colspan="2" data-position="v17x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v17x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v17x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v17x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">4</td>
              <td colspan="10" class="align-left">减：销售费用</td>
              <td colspan="2" data-position="v18x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v18x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v18x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">5</td>
              <td colspan="10" class="align-left">减：管理费用</td>
              <td colspan="2" data-position="v19x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v19x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v19x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v19x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v19x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">6</td>
              <td colspan="10" class="align-left">减：研发费用</td>
              <td colspan="2" data-position="v20x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v20x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v20x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v20x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v20x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">7</td>
              <td colspan="10" class="align-left">减：财务费用</td>
              <td colspan="2" data-position="v21x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v21x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v21x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v21x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v21x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">8</td>
              <td colspan="10" class="align-left">加：其他收益</td>
              <td colspan="2" data-position="v22x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v22x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v22x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v22x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">9</td>
              <td colspan="10" class="align-left">加：投资收益（9.1+9.2）（损失以‘－’号填列）</td>
              <td colspan="2" data-position="v23x2">
                  {{ parseFloatNum(data.v23x2.value) }}
              </td>
          </tr>

          <tr>
              <td class="indent_1em">9.1</td>
              <td colspan="10" class="align-left"><span style="margin-left: 20px;"></span>其中：股权投资确认的处置收益</td>
              <td colspan="2" data-position="v24x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v24x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v24x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v24x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v24x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">9.2</td>
              <td colspan="10" class="align-left"><span style="margin-left: 53px;"></span>其他投资收益</td>
              <td colspan="2" data-position="v25x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v25x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v25x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v25x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">10</td>
              <td colspan="10" class="align-left">加：净敞口套期收益（损失以‘－’号填列）</td>
              <td colspan="2" data-position="v26x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v26x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v26x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v26x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">11</td>
              <td colspan="10" class="align-left">加：公允价值变动收益（损失以‘－’号填列）</td>
              <td colspan="2" data-position="v27x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v27x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v27x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v27x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v27x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">12</td>
              <td colspan="10" class="align-left">加：信用减值损失（损失以‘－’号填列）	</td>
              <td colspan="2" data-position="v28x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v28x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v28x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v28x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v28x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">13</td>
              <td colspan="10" class="align-left">加：资产减值损失（损失以‘－’号填列）</td>
              <td colspan="2" data-position="v29x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v29x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v29x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v29x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v29x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">14</td>
              <td colspan="10" class="align-left">加：资产处置收益（损失以‘－’号填列）	</td>
              <td colspan="2" data-position="v30x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v30x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v30x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v30x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">15</td>
              <td colspan="10" class="align-left">营业利润（亏损以‘－’号填列）</td>
              <td colspan="2" data-position="v31x2">
                  {{ parseFloatNum(data.v31x2.value) }}
              </td>
          </tr>

          <tr>
              <td class="indent_1em">16</td>
              <td colspan="10" class="align-left">加：营业外收入</td>
              <td colspan="2" data-position="v32x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v32x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v32x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v32x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v32x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
              <td class="indent_1em">17</td>
              <td colspan="10" class="align-left">减：营业外支出</td>
              <td colspan="2" data-position="v33x2">
                  <!-- 考题 -->
                  <taxQue :data="data.v33x2" :mode="mode">
                      <template #input>
                          <el-input-number v-model.trim="data.v33x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v33x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v33x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr>
            <td class="indent_1em">18</td>
            <td colspan="10" class="align-left">利润总额（15+16-17）</td>
            <td colspan="2" data-position="v34x2">
                {{ parseFloatNum(data.v34x2.value) }}
            </td>
          </tr>

          <tr>
            <td class="indent_1em">19</td>
            <td colspan="10" class="align-left">加：特定业务计算的应纳税所得额</td>
            <td colspan="2" data-position="v35x2">
              <el-input-number v-model.trim="data.v35x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>

          <tr>
              <td class="indent_1em">19.1</td>
              <td colspan="10" class="align-left">其中：销售未完工产品的收入</td>
              <td colspan="2" data-position="v36x2">
                  <el-input-number v-model.trim="data.v36x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </td>
          </tr>

          <tr>
            <td class="indent_1em">20</td>
            <td colspan="10" class="align-left">减：不征税收入</td>
            <td colspan="2" data-position="v37x2">
              <el-input-number v-model.trim="data.v37x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>

          <tr>
            <td class="indent_1em">21</td>
            <td colspan="10" class="align-left">减：资产加速折旧、摊销（扣除）调减额（填写 A201020）</td>
            <td colspan="2" data-position="v38x2">{{ parseFloatNum(data.v38x2.value) }}</td>
          </tr>

          <tr>
            <td class="indent_1em">22</td>
            <td colspan="10" class="align-left">
                <span class="collapse-bt"
                      @click="isCollapse22 = !isCollapse22"
                >减：免税收入、减计收入、加计扣除（22.1+22.2+……）<el-icon
                    style="margin-left: 3px;"
                    color="#666"><ArrowDownBold /></el-icon></span>
                <el-button type="primary" link @click="viewRow22Dialog(data.v39x2)">填写优惠事项</el-button>
            </td>
            <td colspan="2" data-position="v39x2">{{ parseFloatNum(data.v39x2.value) }}</td>
          </tr>

          <template v-if="!isCollapse22">
              <tr v-for="(item,idx) in (data.v39x2?.subData || [])">
                  <td class="indent_1em">22.{{idx + 1}}</td>
                  <td colspan="10" class="align-left">
                      {{item.name}}<span v-if="item.disCode != null">（减免税代码：{{item.disCode}}）</span>
                  </td>
                  <td colspan="2" data-position="v39x2">{{ parseFloatNum(item.value) }}</td>
              </tr>
          </template>

          <tr>
              <td class="indent_1em">23</td>
              <td colspan="10" class="align-left">
                  <span class="collapse-bt"
                        @click="isCollapse23 = !isCollapse23"
                  >减：所得减免（23.1+23.2+……）<el-icon
                      style="margin-left: 3px;"
                      color="#666"><ArrowDownBold /></el-icon></span>
                  <el-button type="primary" link @click="viewRow23Dialog(data.v40x2)">填写优惠事项</el-button>
              </td>
              <td colspan="2" data-position="v40x2">{{ parseFloatNum(data.v40x2.value) }}</td>
          </tr>

          <template v-if="!isCollapse23">
              <tr v-for="(item,idx) in (data.v40x2?.subData || [])">
                  <td class="indent_1em">23.{{idx + 1}}</td>
                  <td colspan="10" class="align-left">
                      {{item.name}}<span v-if="item.disCode != null">（减免税代码：{{item.disCode}}）</span>
                  </td>
                  <td colspan="2" data-position="v40x2">{{ parseFloatNum(item.value) }}</td>
              </tr>
          </template>

          <tr>
            <td class="indent_1em">24</td>
            <td colspan="10" class="align-left">减：弥补以前年度亏损</td>
            <td colspan="2" data-position="v41x2">
              <el-input-number v-model.trim="data.v41x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>

          <tr>
            <td class="indent_1em">25</td>
            <td colspan="10" class="align-left">实际利润额（18+19-20-21-22-23-24）\ 按照上一纳税年度应纳税所得额平均额确定的应纳税所得额</td>
            <td colspan="2" data-position="v42x2">{{ parseFloatNum(data.v42x2.value) }}</td>
          </tr>

          <tr>
            <td class="indent_1em">26</td>
            <td colspan="10" class="align-left">税率(25%)</td>
            <td colspan="2" data-position="v43x2">{{ data.v43x2.value * 100 }}%</td>
          </tr>

          <tr>
            <td class="indent_1em">27</td>
            <td colspan="10" class="align-left">应纳所得税额（25×26）</td>
            <td colspan="2" data-position="v44x2">{{ parseFloatNum(data.v44x2.value) }}</td>
          </tr>

          <tr>
            <td class="indent_1em">28</td>
            <td colspan="10" class="align-left">
                <span class="collapse-bt"
                      @click="isCollapse28 = !isCollapse28"
                >减：减免所得税额（28.1+28.2+……）<el-icon
                    style="margin-left: 3px;"
                    color="#666"><ArrowDownBold /></el-icon></span>
                <el-button type="primary" link @click="viewRow28Dialog(data.v45x2, data.v46x2)">填写优惠事项</el-button>
            </td>
            <td colspan="2" data-position="v45x2">{{ parseFloatNum(data.v45x2.value) }}</td>
          </tr>

          <template v-if="!isCollapse28">
              <tr>
                  <td class="indent_1em">28.1</td>
                  <td colspan="10" class="align-left">符合条件的小型微利企业减免企业所得税</td>
                  <td colspan="2" data-position="v46x2">{{ parseFloatNum(data.v46x2.value) }}</td>
              </tr>
          </template>

          <tr>
              <td class="indent_1em">29</td>
              <td colspan="10" class="align-left">
                  <span class="collapse-bt"
                        @click="isCollapse29 = !isCollapse29"
                  >减：抵免所得税额 <el-icon
                      style="margin-left: 3px;"
                      color="#666"><ArrowDownBold /></el-icon></span>
                  <el-button type="primary" link @click="viewRow29Dialog(data.v47x2)">填写优惠事项</el-button>
              </td>
              <td colspan="2" data-position="v47x2">
                  {{ parseFloatNum(data.v47x2.value) }}
<!--                  <el-input-number v-model.trim="data.v47x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />-->
              </td>
          </tr>

          <template v-if="!isCollapse29">
              <tr v-for="(item,idx) in (data.v47x2?.subData || [])">
                  <td class="indent_1em">29.{{idx + 1}}</td>
                  <td colspan="4" class="align-left">
                      <span v-if="idx == 0">其中：</span>本年允许抵免专用设备投资额
                  </td>
                  <td colspan="6" class="align-left">
                      {{item.name}}<span v-if="item.disCode != null">（减免税代码：{{item.disCode}}）</span>
                  </td>
                  <td colspan="2" data-position="v47x2">{{ parseFloatNum(item.value) }}</td>
              </tr>
          </template>

          <tr>
              <td class="indent_1em">30</td>
              <td colspan="10" class="align-left">减：本年累计已预缴所得税额</td>
              <td colspan="2" data-position="v48x2">
                  <el-input-number v-model.trim="data.v48x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </td>
          </tr>

          <tr>
              <td class="indent_1em">31</td>
              <td colspan="10" class="align-left">减：特定业务预缴（征）所得税额</td>
              <td colspan="2" data-position="v49x2">
                  <el-input-number v-model.trim="data.v49x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </td>
          </tr>

          <tr>
              <td class="indent_1em">32</td>
              <td colspan="10" class="align-left">本期应补（退）所得税额（27-28-29-30-31） \ 税务机关确定的本期应纳所得税额</td>
              <td colspan="2" data-position="v50x2">
                  <taxQue :data="data.v50x2" :mode="mode">
                      <template #input>
                          {{ parseFloatNum(data.v50x2.value) }}
                      </template>
                      <template #score>
                          <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v50x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                          <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v50x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                      </template>
                  </taxQue>
              </td>
          </tr>

          <tr class="table-head">
            <td colspan="13" class="td-center bold-txt">汇总纳税企业总分机构税款计算</td>
          </tr>

          <tr>
            <td class="indent_1em">33</td>
            <td colspan="2" rowspan="4" class="td-center">总机构</td>
            <td colspan="8">总机构本期分摊应补（退）所得税额（34+35+36）</td>
            <td colspan="2" data-position="v52x2">{{ parseFloatNum(data.v52x2.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">34</td>
            <td colspan="8">其中：总机构分摊应补（退）所得税额（填写A202000表）</td>
            <td colspan="2" data-position="v53x2">
              <el-input-number v-model.trim="data.v53x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">35</td>
            <td colspan="8" class="indent_2em">财政集中分配应补（退）所得税额（填写A202000表）</td>
            <td colspan="2" data-position="v54x2">
              <el-input-number v-model.trim="data.v54x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">36</td>
            <td colspan="8" class="indent_2em">总机构主体生产经营部门分摊应补（退）所得税额（填写A202000表）	</td>
            <td colspan="2" data-position="v55x2">
              <el-input-number v-model.trim="data.v55x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">37</td>
            <td colspan="2" rowspan="2" class="td-center">分支机构</td>
            <td colspan="8">分支机构本期分摊比例</td>
            <td colspan="2" data-position="v56x2">
              <el-input-number v-model.trim="data.v56x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_1em">38</td>
            <td colspan="8">分支机构本期分摊应补（退）所得税额</td>
            <td colspan="2" data-position="v57x2">
              <el-input-number v-model.trim="data.v57x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>

          <tr class="table-head">
            <td colspan="13" class="td-center bold-txt">实际缴纳企业所得税计算</td>
          </tr>

          <tr>
            <td class="indent_1em">FZ1</td>
            <td colspan="10" class="align-left">中央级收入实际应纳税额[本期：32行×60%或(34行+35行+36行)×60%或38行×60%]</td>
            <td colspan="2" data-position="v59x2">{{ parseFloatNum(data.v59x2.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">FZ2</td>
            <td colspan="10" class="align-left">中央待分配收入应纳税额[本期：(34行+35行)×20%]</td>
            <td colspan="2" data-position="v60x2">{{ parseFloatNum(data.v60x2.value) }}</td>
          </tr>
          <tr>
              <td class="indent_1em">FZ3</td>
              <td colspan="10" class="align-left">地方级收入应纳税额[本期：32行×40%或(34行+35行)×20%+36行*40%或(34行+35行+36行)×40%或38行×40%]</td>
              <td colspan="2" data-position="v61x2">{{ parseFloatNum(data.v61x2.value) }}</td>
          </tr>


          <tr>
            <td class="indent_1em">39</td>
            <td colspan="2" rowspan="3">减：民族自治地区企业所得税地方分享部分：</td>
            <td colspan="2" rowspan="3">
              <el-radio-group v-model="data.v62x1.value" style="flex-direction: column; align-items: flex-start; padding: 0 10px">
                <el-radio value="0">无</el-radio>
                <el-radio value="1">免征</el-radio>
                <el-radio value="2">减征</el-radio>
              </el-radio-group>

            </td>
            <td colspan="1" rowspan="3">减征幅度</td>
            <td colspan="2" rowspan="3">0.000000%</td>
            <td colspan="3">本期实际减免金额（FZ3×减征幅度）</td>
            <td colspan="2" data-position="v62x2">{{ parseFloatNum(data.v62x2.value) }}</td>
          </tr>

          <tr>
            <td class="indent_1em">39.1</td>
            <td colspan="3">本机构本年累计金额（39行的本年累计）</td>
            <td colspan="2" data-position="v63x2">{{ parseFloatNum(data.v63x2.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">39.2</td>
            <td colspan="3">本年累计应减免金额（总机构及分支机构的本年累计，总机构填报）</td>
            <td colspan="2" data-position="v64x2">
              <el-input-number v-model.trim="data.v64x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>

          <tr>
            <td class="indent_1em">FZ4</td>
            <td colspan="10">地方级收入实际应纳税额（本期：FZ3-39）</td>
            <td colspan="2" data-position="v65x2">{{ parseFloatNum(data.v65x2.value) }}</td>
          </tr>
          <tr>
            <td class="indent_1em">40</td>
            <td colspan="10">实际应补（退）所得税额（本期：FZ1+FZ2+FZ4）</td>
            <td colspan="2" data-position="v66x2">
              <el-input-number v-model.trim="data.v66x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>

          <tr>
            <td colspan="13">
              <p class="text-left">谨声明：本纳税申报表是根据国家税收法律法规及相关规定填报的，是真实的、可靠的、完整的。</p>
              <p class="text-left">纳税人（签章）：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日</p>
            </td>
          </tr>
          <tr>
            <td colspan="7">经办人： 经办人身份证号： 代理机构签章： 代理机构统一社会信用代码：</td>
            <td colspan="6">受理人： 受理税务机关（章）： 受理日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 5px 0; display: flex; justify-content: flex-end">
      <span>国家税务总局监制</span>
    </div>

      <tax21-row22-dialog
          v-model:visible="row22DiaVis"
          :current-data="currentData"
          @onConfirm="confirmRow22"
      />

      <tax21-row23-dialog
          v-model:visible="row23DiaVis"
          :current-data="currentData"
          @onConfirm="confirmRow23"
      />

      <tax21-row29-dialog
          v-model:visible="row29DiaVis"
          :current-data="currentData"
          @onConfirm="confirmRow29"
      />

      <tax21-row28-dialog
          v-model:visible="row28DiaVis"
          :current-data="currentData"
          @onConfirm="confirmRow28"
      />

  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../../reportTaxStaticConfig.js";
import taxQue from "../../../cmp/taxQue.vue";
import ElCheckMultiGroup from "@/components/EnhanceForm/ElCheckMultiGroup.vue";
import tax21Row22Dialog from './tax21Row22Dialog.vue'
import tax21Row23Dialog from './tax21Row23Dialog.vue'
import tax21Row29Dialog from './tax21Row29Dialog.vue'
import tax21Row28Dialog from './tax21Row28Dialog.vue'

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});

// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};

// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const radio1 = ref("1");
const radio2 = ref("1");
function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 计算1：从业人数-季度平均值
        const v1x9 = getAverage(
          [
            [data.value.v1x1.value, data.value.v1x2.value],
            [data.value.v1x3.value, data.value.v1x4.value],
            [data.value.v1x5.value, data.value.v1x6.value],
            [data.value.v1x7.value, data.value.v1x8.value],
          ].map((item) => new Big(new Big(item[0]).plus(item[1])).div(2))
        );

        data.value.v1x9.value = Math.ceil(v1x9.toNumber());

        // 计算2：资产总额-季度平均值
        const v2x9 = getAverage(
          [
            [data.value.v2x1.value, data.value.v2x2.value],
            [data.value.v2x3.value, data.value.v2x4.value],
            [data.value.v2x5.value, data.value.v2x6.value],
            [data.value.v2x7.value, data.value.v2x8.value],
          ].map((item) => new Big(new Big(item[0]).plus(item[1])).div(2))
        );

        data.value.v2x9.value = v2x9.round(2).toNumber();

        // 计算3： 9=9.1+9.2
        data.value.v23x2.value = new Big(data.value.v24x2.value).plus(data.value.v25x2.value).round(2).toNumber();

        //计算4： 15行= 营业利润（亏损以‘－’号填列）
        data.value.v31x2.value = new Big(data.value.v12x2.value) // 1
            .minus(data.value.v16x2.value) // -2
            .minus(data.value.v17x2.value) // -3
            .minus(data.value.v18x2.value) // -4
            .minus(data.value.v19x2.value) // -5
            .minus(data.value.v20x2.value) // -6
            .minus(data.value.v21x2.value) // -7
            .plus(data.value.v22x2.value) // +8
            .plus(data.value.v23x2.value) // +9
            .plus(data.value.v26x2.value) // + 10
            .plus(data.value.v27x2.value) // + 11
            .plus(data.value.v28x2.value) // + 12
            .plus(data.value.v29x2.value) // + 13
            .plus(data.value.v30x2.value) // + 14
            .round(2).toNumber();

        // 计算5：18行利润总额（15+16-17）
        data.value.v34x2.value = new Big(data.value.v31x2.value)
            .plus(data.value.v32x2.value) // +16
            .minus(data.value.v33x2.value) // -17
            .round(2).toNumber();

        // 计算6：25实际利润额（18+19-20-21-22-23-24）
        data.value.v42x2.value = new Big(data.value.v34x2.value)
            .plus(data.value.v35x2.value) // + 19
            .minus(data.value.v37x2.value) // -20
            .minus(data.value.v38x2.value) // -21
            .minus(data.value.v39x2.value) // -22
            .minus(data.value.v40x2.value) // -23
            .minus(data.value.v41x2.value) // -24
            .round(2).toNumber()

        // 计算7：27应纳所得税额（25×26）
        data.value.v44x2.value = new Big(data.value.v42x2.value)
            .times(data.value.v43x2.value) // *26
            .round(2).toNumber()


        // 计算8：28.1 = 行25 * 0.2
        data.value.v46x2.value = data.value.v3x2.value == '1' ?
            new Big(data.value.v42x2.value).times(0.2).round(2).toNumber()
            : 0

        // 计算9：28=28.1
        data.value.v45x2.value = data.value.v46x2.value

        // 计算10：32本期应补（退）所得税额
        data.value.v50x2.value = new Big(data.value.v44x2.value) // 27
            .minus(data.value.v45x2.value) // -28
            .minus(data.value.v47x2.value) // -29
            .minus(data.value.v48x2.value) // -30 让填，不判分
            .minus(data.value.v49x2.value) // -31 让填，不判分
            .round(2).toNumber()


        // 计算11：尾部几个不参与判分的计算
        data.value.v59x2.value = new Big(data.value.v50x2.value).times(0.6) .round(2).toNumber() // FZ1=32*0.6
        data.value.v61x2.value = new Big(data.value.v50x2.value).times(0.4) .round(2).toNumber() // FZ3=32*0.4
        data.value.v65x2.value = new Big(data.value.v61x2.value).minus(0) .round(2).toNumber() // FZ4=FZ3-39

        data.value.v66x2.value = new Big(data.value.v59x2.value)
            .plus(0)
            .plus(data.value.v65x2.value) // 40=FZ1+FZ2+FZ4
            .round(2).toNumber()
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

function getRate(value, options) {
  const option = options.find((item) => item.value == value);

  if (option) {
    return option.rate;
  }

  return 0;
}

function getAverage(arr = [1, 2, 3, 0]) {
  let count = 0;
  let res = 0;
  for (let i = 0; i < arr.length; i++) {
    let item = arr[i];
    if (item > 0) {
      count++;
      res = new Big(res).plus(item);
    }
  }

  if (count > 0) {
    return new Big(res).div(count);
  }

  return new Big(0);
}

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});

const row22DiaVis = ref(false)
const currentData = ref({})

function viewRow22Dialog(data) {
    currentData.value = data
    row22DiaVis.value = true
}

function confirmRow22(resData, total) {
    data.value.v39x2.subData = resData
    data.value.v39x2.value = total
    isCollapse22.value = false
}

const row23DiaVis = ref(false)

function viewRow23Dialog(data) {
    currentData.value = data
    row23DiaVis.value = true
}

function confirmRow23(resData, total) {
    data.value.v40x2.subData = resData
    data.value.v40x2.value = total
    isCollapse23.value = false
}

const row29DiaVis = ref(false)

function viewRow29Dialog(data) {
    currentData.value = data
    row29DiaVis.value = true
}

function confirmRow29(resData, total) {
    data.value.v47x2.subData = resData
    data.value.v47x2.value = total
    isCollapse29.value = false
}

const row28DiaVis = ref(false)

function viewRow28Dialog(data1, data2) {
    currentData.value = { // 28行是特殊处理过的，只有“符合条件的小型微利企业减免企业所得税”。其他的实际无法选中，只是显示了看看
        self28: data1,
        sub281: data2
    }
    row28DiaVis.value = true
}

function confirmRow28(resData, total) {
    //data.value.v45x2.subData = resData
    //data.value.v45x2.value = total
    isCollapse28.value = false
}

const isCollapse29 = ref(false), isCollapse28 = ref(false), isCollapse22 = ref(false), isCollapse23 = ref(false)

</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;
}

.bold-txt {
    font-weight: 700;
}

.align-left {
    text-align: left;
}

.collapse-bt {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    margin-right: 15px;
    user-select: none;
}

</style>
